import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathLessThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMathLessThan"><Path d="M18.5 6L5.5 11.5L18.5 17" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMathLessThan;
